import './App.css'
import Footer from './components/Footer'
import Sidebar from './components/Sidebar'
import Preview from './components/Preview'
import HotJar from './analytics/hotjar'
import { useStore } from './store'
import { useContext, useEffect } from 'react'
import { AppConfigContext, AppConfig } from './context/AppConfig'
import CTFSidebar from './components/CTFSidebar'
import VariantWrapper from './components/VariantWrapper'
import { variants } from './constants/variant'
import { useSafariOrientationChangeHandler } from './hooks/useSafariOrientationChangeHandler'
import use3DViewerEvent from './hooks/use3DViewerEvent'
import { analyticsEvents } from './analytics/events'
import { captureEvent } from './analytics'
import InactivityPopup from './components/InactivityPopup'

function Analytics() {
  const { data, setEngaged, engaged, setProduct } = useStore()
  const { isWideMode, isSWApp, isPDApp, isEWApp, isOfficesApp } = useContext(AppConfigContext)

  use3DViewerEvent('analytics', ({ payload }) => {
    const event = Object.values(analyticsEvents).find((e) => e.name === payload.event)
    if (!event) {
      console.warn(`Event ${payload.event} is not valid or known event`)
      return
    }
    captureEvent(event)
  })

  useEffect(() => {
    if (isOfficesApp) {
      setProduct('SW_OFF')
      return
    }
    if (isPDApp) {
      setProduct('CW_PD')
      return
    }
    if (isEWApp) {
      setProduct('EW')
      return
    }
    if (isSWApp) {
      setProduct('VW')
      return
    }
    if (isWideMode) {
      setProduct('CW_CTF')
      return
    }
  }, [isWideMode, setProduct, isSWApp, isPDApp, isEWApp, isOfficesApp])

  useEffect(() => {
    ;['mousedown', 'touchstart', 'keydown'].forEach((e) => {
      document.addEventListener(e, () => {
        if (!engaged) {
          setEngaged(true)
        }
      })
    })
  }, [engaged, setEngaged])

  return data.appLoaded ? <HotJar /> : null
}

function SidebarContainer() {
  const { isWideMode } = useContext(AppConfigContext)

  useEffect(() => {
    // Set the global CSS variable dynamically from JavaScript
    document.documentElement.style.setProperty('--sidebar-shown-width', isWideMode ? '0px' : '340px')
  }, [isWideMode])

  return (
    <VariantWrapper hide={[variants.of, variants.br, variants.sf]}>
      {isWideMode ? <CTFSidebar /> : <Sidebar className="hidden lg:block" />}
    </VariantWrapper>
  )
}

function App() {
  const { isEWApp, isOfficesApp, block_analytics, isBrodskyApp, hide_disclaimer, isSFApp, hide_footer } = useContext(AppConfigContext)

  // Fix for Safari on iOS : https://sparx-app.atlassian.net/browse/AT-1277
  useSafariOrientationChangeHandler()

  return (
    <>
      <InactivityPopup />
      {!block_analytics && <Analytics />}
      <div className="h-full w-full">
        <div className={`h-full ${isBrodskyApp || isSFApp || hide_footer ? 'lg:h-full' : 'lg:h-[calc(100%-30px)]'} flex`}>
          <Preview />
          <SidebarContainer />
        </div>
        {!hide_footer && (
          <VariantWrapper hide={[variants.br, variants.sf]}>
            <Footer disclaimer={(isEWApp || isOfficesApp) && !hide_disclaimer} className="hidden lg:flex" />
          </VariantWrapper>
        )}
      </div>
    </>
  )
}

function Config() {
  return (
    <AppConfig>
      <App />
    </AppConfig>
  )
}

export default Config
